import images from "./images";

const projects = [
{
    id: 1,
    image: images.project1,
    title: "Custom Furniture",
    details: {
        date: "March 18, 2024",
        client: "Urban Loft Interiors",
        category: "Custom Craft",
        duration: "6 Weeks",
        location: "Downtown Seattle, WA",
        cost: "Quoted per piece and material selection",
        leadDesigner: "Samantha Woodrow"
    },
    paragraphs: [
        "Blending artistry with functionality, the Custom Furniture project delivered one-of-a-kind handcrafted pieces tailored to the client's modern-industrial aesthetic. Every item was designed to reflect the unique space and personality of the interior.",
        "From concept sketches to final installation, our team ensured high-quality craftsmanship, sustainable material sourcing, and ergonomic comfort. The final collection featured reclaimed wood, metal inlays, and seamless joinery."
    ],
    gallery: [
        images.project1Gallery1,
        images.project1Gallery2,
        images.project1Gallery3,
        images.project1Gallery4,
        images.project1Gallery5,
        images.project1Gallery6,
    ],
    challenges: [
        "Sourcing Consistent Reclaimed Materials",
        "Meeting Tight Deadlines Without Compromising Quality",
        "Balancing Aesthetic Vision with Functional Design"
    ],
    solutions: [
        "Partnering with Trusted Local Suppliers",
        "Streamlined Workshop Scheduling and Milestone Tracking",
        "Iterative Design Reviews and Client Feedback Integration"
    ],
    results: [
        "Delivered a Bespoke Furniture Collection Ahead of Schedule",
        "Enhanced Client Interior with Unique, Functional Art Pieces",
        "Increased Interest in Sustainable Custom Design Offerings"
    ]
},
{
    id: 2,
    image: images.project2,
    title: "Window Installations",
    details: {
        date: "January 12, 2024",
        client: "Greenview Residential Developments",
        category: "Carpentry Work",
        duration: "3 Weeks",
        location: "Suburban Neighborhoods, Portland, OR",
        cost: "Varies by window type and installation complexity",
        leadDesigner: "Marcus Holloway"
    },
    paragraphs: [
        "Our Window Installations project focused on enhancing energy efficiency, aesthetics, and structural integrity for a series of modern homes. We worked closely with homeowners and architects to deliver customized carpentry solutions.",
        "Each installation balanced form and function, using precision-fit techniques and weather-resistant materials. Whether traditional sash or contemporary casement styles, every window was installed to optimize insulation and natural light."
    ],
    gallery: [
        images.project2Gallery1,
        images.project2Gallery2,
        images.project2Gallery3,
        images.project2Gallery4,
        images.project2Gallery5,
        images.project2Gallery6,
    ],
    challenges: [
        "Inconsistent Wall Openings in Older Homes",
        "Weather Delays During Exterior Installations",
        "Maintaining Airtight Seals Across Varying Materials"
    ],
    solutions: [
        "Custom Framing Adjustments and On-Site Measurements",
        "Flexible Scheduling and Use of Weather-Resistant Barriers",
        "High-Precision Sealant Application and Quality Control Checks"
    ],
    results: [
        "Improved Thermal Efficiency and Reduced Energy Costs",
        "Increased Curb Appeal and Property Value",
        "Client Satisfaction with Tailored, Durable Installations"
    ]
},
{
    id: 3,
    image: images.project3,
    title: "Home Decor",
    details: {
        date: "April 7, 2024",
        client: "Custom Craft",
        category: "Custom Craft",
        duration: "4 Weeks",
        location: "Santa Fe, New Mexico",
        cost: "Based on scope, materials, and design complexity",
        leadDesigner: "Lena Marquette"
    },
    paragraphs: [
        "The Home Decor project transformed ordinary living spaces into personalized, artful environments. Each decor element—from handcrafted wall panels to bespoke shelving—was designed to harmonize with the home's Southwest-inspired architecture.",
        "We collaborated closely with the client to create unique focal points using natural materials, hand-painted finishes, and custom textiles. The result was a warm, cohesive interior that reflected the homeowner's lifestyle and aesthetic."
    ],
    gallery: [
        images.project3Gallery1,
        images.project3Gallery2,
        images.project3Gallery3,
        images.project3Gallery4,
        images.project3Gallery5,
        images.project3Gallery6,
    ],
    challenges: [
        "Integrating New Decor with Existing Structures",
        "Balancing Artistic Expression with Daily Function",
        "Sourcing Authentic Regional Materials"
    ],
    solutions: [
        "3D Mockups and On-Site Prototyping",
        "Functional Design Reviews with the Client",
        "Partnered with Local Artisans and Material Vendors"
    ],
    results: [
        "A Unique, Personalized Living Space",
        "Seamless Blend of Functionality and Style",
        "Increased Client Engagement and Design Satisfaction"
    ]
},
{
    id: 4,
    image: images.project4,
    title: "Kitchen Cabinets",
    details: {
        date: "May 3, 2024",
        client: "The Langston Renovation Project",
        category: "Cabinet Design",
        duration: "5 Weeks",
        location: "Nashville, TN",
        cost: "Estimates based on size, finish, and hardware selections",
        leadDesigner: "Julian Park"
    },
    paragraphs: [
        "As part of a full kitchen remodel, the Kitchen Cabinets project delivered custom-designed cabinetry that combined sleek functionality with timeless style. Every cabinet was tailored to fit the client's storage needs and cooking habits.",
        "From soft-close drawers to integrated spice racks and concealed appliances, each element was meticulously planned and crafted. The finish—matte white with walnut trim—brought warmth and modern elegance to the kitchen."
    ],
    gallery: [
        images.project4Gallery1,
        images.project4Gallery2,
        images.project4Gallery3,
        images.project4Gallery4,
        images.project4Gallery5,
        images.project4Gallery6,
    ],
    challenges: [
        "Maximizing Storage in a Compact Kitchen Layout",
        "Coordinating with Plumbing and Electrical Work",
        "Ensuring Durable Finishes in High-Traffic Areas"
    ],
    solutions: [
        "Custom Modular Cabinet Designs with Vertical Storage",
        "Collaborative Scheduling with Other Trades",
        "Use of High-Performance Laminates and Protective Coatings"
    ],
    results: [
        "A Functional, Stylish, and Space-Efficient Kitchen",
        "Improved Workflow and Daily Usability for the Homeowner",
        "Client Praise for Precision Craftsmanship and Attention to Detail"
    ]
},
{
    id: 5,
    image: images.project5,
    title: "Door Installations",
    details: {
        date: "February 28, 2024",
        client: "Northgate Property Management",
        category: "Carpentry Work",
        duration: "2 Weeks",
        location: "Twin Cities Metro Area, MN",
        cost: "Varies by door type, hardware, and material",
        leadDesigner: "Carlos Mendes"
    },
    paragraphs: [
        "The Door Installations project focused on replacing outdated interior and exterior doors across multiple rental properties, enhancing both security and aesthetic appeal. Our team delivered precise, efficient installation for a variety of door styles.",
        "With a focus on craftsmanship and longevity, we ensured proper alignment, weatherproofing, and hardware integration. Each door was selected to match architectural elements while meeting modern performance standards."
    ],
    gallery: [
        images.project5Gallery1,
        images.project5Gallery2,
        images.project5Gallery3,
        images.project5Gallery4,
        images.project5Gallery5,
        images.project5Gallery6,
    ],
    challenges: [
        "Irregular Framing in Older Units",
        "Tenant Access and Scheduling Constraints",
        "Weatherproofing for Exterior Installations"
    ],
    solutions: [
        "Custom Trimming and Shimming for Perfect Fit",
        "Coordinated Access with Property Managers",
        "Use of Durable Seals and Threshold Components"
    ],
    results: [
        "Improved Security and Energy Efficiency",
        "Enhanced Visual Appeal and Tenant Satisfaction",
        "Streamlined Process for Future Installations"
    ]
},
{
    id: 6,
    image: images.project6,
    title: "Bathroom Cabinets",
    details: {
        date: "March 15, 2024",
        client: "Willow Grove Renovations",
        category: "Cabinet Design",
        duration: "3 Weeks",
        location: "Asheville, NC",
        cost: "Customized based on layout, finish, and hardware",
        leadDesigner: "Naomi Ellis"
    },
    paragraphs: [
        "The Bathroom Cabinets project focused on bringing both elegance and practicality to compact and master bathrooms alike. Designed for durability and daily use, each cabinet unit blended storage efficiency with spa-like style.",
        "Cabinetry was crafted using moisture-resistant materials, featuring soft-close drawers, under-sink organizers, and seamless countertop integration. Finishes included warm oak veneer and matte black hardware for a modern yet timeless aesthetic."
    ],
    gallery: [
        images.project6Gallery1,
        images.project6Gallery2,
        images.project6Gallery3,
        images.project6Gallery4,
        images.project6Gallery5,
        images.project6Gallery6,
    ],
    challenges: [
        "Limited Space and Custom Plumbing Layouts",
        "Maintaining Style Consistency Across Multiple Bathrooms",
        "Preventing Moisture Damage Over Time"
    ],
    solutions: [
        "Compact, Modular Cabinet Designs",
        "Unified Design Templates Adapted per Room",
        "Water-Resistant Coatings and Ventilation Considerations"
    ],
    results: [
        "Increased Bathroom Storage and Functionality",
        "Visually Cohesive and Modernized Interiors",
        "High Client Satisfaction and Low Maintenance Needs"
    ]
}

];

export default projects;